import { Injectable } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { ISelectionAlert } from './selection-alert';
import { DocService } from '../../services/doc.service';
import { Filter } from './filter.model';
import { ActivatedRoute } from '@angular/router';
import { DocsDataSource } from 'src/app/components/review/browse/docs-data-source';
import { CasesService } from '@services/cases.service';

@Injectable({
	providedIn: 'root'
})
export class SelectionService {

	pageSize = 25;
	selection = new SelectionModel<any>(true, []);
	selectionAlert: ISelectionAlert;
	selectAllFlag: boolean;
	dataSource: DocsDataSource;
	selectedFilter: Filter;
	operationAlert: string;
	searchOperationAlert: string;

	get SelectedCount(): number {
		return this.selectAllFlag ? this.dataSource.count : this.selection.selected.length;
	}

	constructor(
		private docService: DocService,
		private activatedRoute: ActivatedRoute,
		private casesService: CasesService
	) {
		this.dataSource = new DocsDataSource(docService);
		this.selection.changed.subscribe(() => {
			this.selectAllFlag = false;
			this.onSelectionChange();
		});
		this.selectDocsFromQueryParam();
		// Deselect all whenever current case changes anywhere in the app.
		this.casesService.listenCurrentCase().subscribe(() => {
			this.deselectAll();
		});
	}

	getSavedFilterId() {
		return this.selectedFilter == null ? null : this.selectedFilter.savedFilterId;
	}

	selectDocsFromQueryParam() {
		this.activatedRoute.queryParams.subscribe(params => {
			const selectedDocIdString = params['SelectedDocIds'];
			if (selectedDocIdString == null)
				return;

			const selectedDocIds = selectedDocIdString.toLowerCase().split(',');
			this.selectAllFlag = false;
			this.dataSource.curPage.forEach(doc => {
				if (selectedDocIds.includes(doc.docId))
					this.selection.select(doc);
			});
		});
	}

	selectDocsFromSelectionInfo(selectionInfo: { selectAll: boolean; selectedDocIds: Array<string> }) {
		if (selectionInfo.selectAll) {
			this.selectAll();
		} else {
			this.selection.clear();
			this.dataSource.curPage.forEach(val => {
				if (selectionInfo.selectedDocIds.includes(val.docId))
					this.selection.select(val);
			});
		}
	}

	selectCurrentPage() {
		this.selectAllFlag = false;
		this.dataSource.curPage.forEach(doc => {
			this.selection.select(doc);
		});
		this.onSelectionChange();
	}

	selectAll() {
		this.selectCurrentPage();
		this.selectAllFlag = true;
		this.onSelectionChange();
	}

	deselectAll() {
		this.selection.clear();
	}

	onSelectionChange() {
		const totalRowsSelected = this.SelectedCount;

		if (totalRowsSelected === 0) {
			this.selectionAlert = null;
			return;
		}

		if (totalRowsSelected < this.pageSize) {
			if (totalRowsSelected === 1) {
				this.selectionAlert = {
					Title: {
						Count: totalRowsSelected,
						Suffix: ' document has been selected.'
					},
					ShowClearButton: true
				};
			} else {
				this.selectionAlert = {
					Title: {
						Count: totalRowsSelected,
						Suffix: ' documents have been selected.'
					},
					ShowClearButton: true
				};
			}
		} else if (totalRowsSelected === this.pageSize) {
			this.selectionAlert = {
				Title: {
					Prefix: 'All ',
					Count: totalRowsSelected,
					Suffix: ' documents on this page have been selected.'
				},
				Button: {
					Prefix: 'Select all ',
					Count: this.dataSource.count,
					Suffix: '  documents in list'
				},
				ShowClearButton: false
			};
		} else { // All selected
			this.selectionAlert = {
				Title: {
					Count: totalRowsSelected,
					Prefix: 'All ',
					Suffix: ' documents in list have been selected.'
				},
				ShowClearButton: true
			};
		}
	}

	resetState() {
		this.selectionAlert = null;
		this.selectedFilter = null;
		this.operationAlert = null;
		this.searchOperationAlert = null;
		this.dataSource.clear();
	}
}
